import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import ConfigTable from '../../../components/ConfigTable';

interface ConfigDialogProps {
  open: boolean;
  onClose: () => void;
  selectedConfig: any; // You can replace 'any' with the appropriate type if known
  t: (key: string) => string;
}

const ConfigDialog: React.FC<ConfigDialogProps> = ({ open, onClose, selectedConfig, t }) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen style={{ margin: '100px'}} PaperProps={{ style: { width: '1000px'} }}>
      <DialogTitle>{t("Config File Content")}</DialogTitle>
      <DialogContent>
        <ConfigTable config={selectedConfig} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigDialog;
